import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { apiClient } from "@/lib/apiClient";

/** Prüft den gewählten MWST-Satz gegen das Leistungs-/Rechnungsdatum (Satz-Tabelle mit Gültigkeit). */
export function VatRateDateHint({ companyId, date, ratePercent, onApply }) {
  const [check, setCheck] = useState(null);
  useEffect(() => {
    if (!companyId || !date || ratePercent == null || Number(ratePercent) === 0) { setCheck(null); return; }
    let alive = true;
    apiClient.get(`/companies/${companyId}/vat-rates/for-date`, { params: { date, rate: ratePercent } })
      .then((r) => alive && setCheck(r.data.check)).catch(() => alive && setCheck(null));
    return () => { alive = false; };
  }, [companyId, date, ratePercent]);
  if (!check || check.valid) return null;
  return (
    <div className="mt-1 flex flex-wrap items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-2 py-1.5 text-[11px] text-amber-800" data-testid="vat-rate-date-hint">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span>{check.message}</span>
      {check.expected_rate != null && onApply && (
        <button type="button" onClick={() => onApply(check.expected_rate)} className="rounded-full bg-amber-600 px-2 py-0.5 font-medium text-white hover:bg-amber-700" data-testid="vat-rate-date-apply">
          Auf {check.expected_rate} % setzen
        </button>
      )}
    </div>
  );
}
